import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eae7e4b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Create Your Own ", -1))
const _hoisted_3 = [
  _hoisted_2
]

import { computed } from 'vue';
import { useClaimStore } from '@/store/claimStore';

const STUDIO_LINK_CAMPAIGN_AND_MEDIUM = 'utm_medium=side-bar&utm_campaign=app-link';

type CreateYourOwnProps = {
  instanceSlug?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateYourOwn',
  props: {
    instanceSlug: { default: '' }
  },
  setup(__props: any) {

const props = __props;



const store = useClaimStore();

const studioLink = computed(() => {
  const utmContent = props.instanceSlug ? `&utm_content=${props.instanceSlug}` : '';
  const appPath = store.appId ? `apps/${store.appId}/new` : '';
  return `https://studio.manifold.xyz/${appPath}?utm_source=c&${STUDIO_LINK_CAMPAIGN_AND_MEDIUM}${utmContent}`;
});

return (_ctx: any,_cache: any) => {
  return (studioLink.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "campaign-view-original-media",
        target: "_blank",
        href: studioLink.value
      }, _hoisted_3, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})